import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * Public alias for splash images at `/splash/{w}x{h}` (no /api prefix).
 * Immediately window-navigates to the backend endpoint. Used by external
 * install-banner references and OEM shortcut providers.
 */
export default function SplashRedirect() {
  const { size } = useParams();
  useEffect(() => {
    const base = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
    const safe = (size || "512x512").replace(/[^0-9x]/g, "");
    window.location.replace(`${base}/api/splash/${safe}.png`);
  }, [size]);
  return null;
}
